import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from "@angular/common/http";
import { Tarifa } from '../clases/tarifa';
import { RequestServicio } from '../clases/request-servicio';
import { ResponseServicio } from '../clases/response-servicio';
import { CancelarServicio } from '../clases/cancelar-servicio';
import { map } from 'rxjs/operators';
import { posicionConductor } from '../clases/posicionConductor';
@Injectable({
  providedIn: 'root'
})
export class SolicitarServicioService {

  constructor(private _http: HttpClient) {
  }

  requestDireccion(lat: any, lng: any) {
    const url = environment.URL_BASE + 'geocode/json?latlng=' + lat + ',' + lng;
    return this._http.get(url);
  }

  requestDireccionDefault(lat: any, lng: any) {
    const url = environment.URL_BASE + 'geocode/json?latlng=' + lat + ',' + lng;
    return this._http.get(url);
  }

  requestTarifa(json: any) {
    //console.log(json);
    const url = environment.URL_BASE + "tarifa/consultar";
    return this._http.post(url, json);
  }

  requestCrearServicio(json: RequestServicio) {
    const url = environment.URL_BASE + "servicio/multisave";
    return this._http.post(url, json);
  }

  requestObtenerConductor(json: ResponseServicio) {
    const url = environment.URL_BASE + "servicio/consultar";
    return this._http.post(url, json);
  }

  requestCancelarServicio(json: CancelarServicio) {
    const url = environment.URL_BASE + "servicio/anular";
    return this._http.post(url, json);
  }

  requestTipoPago(IdCliente: any, isoCountryCode: string) {
    const url = environment.URL_BASE + "tipoPago/all?id=" + IdCliente + '&isoCountryCode=' + isoCountryCode;
    return this._http.get(url);
  }

  requestTipoPagoEmpresa(IdEmpresa) {
    const url = environment.URL_BASE + "tipoPago/all?idEmpresa=" + IdEmpresa;
    return this._http.get(url);
  }

  requestTipoReporte(IdEmpresa) {
    const url = environment.URL_BASE + "tipoPago/getTipoReporte?idEmpresa=" + IdEmpresa;
    return this._http.get(url);
  }


  requestTipoPagoAll(IdCliente: any) {
    const url = environment.URL_BASE + "tipoPago/all?id=" + IdCliente;
    return this._http.get(url);
  }

  requestGeocerca(idEmpresa: any) {
    const url = environment.URL_BASE + "usuario/obtenergeocercas?idEmpresa=" + idEmpresa;
    return this._http.get(url);
  }

  requestTipoServicio(IdCliente: any) {
    const url = environment.URL_BASE + "tiposervicio/all?id="+ IdCliente;
    return this._http.get(url);
  }

  // consultarCodigo(IdCliente: any){
  //   const url = environment.URL_BASE + "promocion/wmObtenerPromocionCliente" +"?idCliente=" + IdCliente;
  //   return this._http.get(url);
  // }

  requestCountry() {
    const url = environment.URL_GET_COUNTRY;
    return this._http.get(url).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  requestCountryCode(latitud:number, longitud:number){
    const url = environment.URL_BASE + 'servicio/getCobertura?latitud=' +  latitud + '&longitud=' + longitud;
    return this._http.get(url).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  requestLstPersonal(IdCliente: any) {
    const url = environment.URL_BASE + "cliente/listarPersonal?idCliente="+ IdCliente 
    return this._http.get(url);
  }

  requestLstSedes(IdEmpresa: any) {
    const url = environment.URL_BASE + "/api/sedes/all?idEmpresa"+ IdEmpresa;
    return this._http.get(url);
  }

  requestTipoServicioEmpresa(idEmpresa: any){
    const url = environment.URL_BASE + "tiposervicio/getTipoReporte?idempresa="+ idEmpresa;
    return this._http.get(url);
  }
  
  conductoresCercanos(lat: any, lng: any) {
    const url = environment.URL_BASE + "tracking/consultaconductores?lat="+ lat +"&lng=" + lng;
    return this._http.get(url);
  }
  
  requestLstPersonalAutocomplete(IdCliente: any, busqueda: string) {
    const url = environment.URL_BASE + "cliente/listarPersonalAutocomplete?idCliente="+ IdCliente+"&busqueda="+busqueda;
    return this._http.get(url);
  }

  enviarNotificacionReserva(idServicio:any){
    const url=environment.URL_BASE+'Notificacion/NotificacionReserva?IdServicio='+idServicio;
    return this._http.get(url)
  }

  requestPosicionConductorDistancia(origen:string, destino:string) {
    var url = environment.URL_BASE+"PosicionConductor/wmposicionConductor?origen="+origen+"&destino="+destino;
    return this._http.get(url);
  }

  multiSaveBloque(data:any){
    const url = environment.URL_BASE + "servicio/multiSaveBloque";
    return this._http.post(url, data);
  }
  
  getPanline(data:any){
    const url = data;
    return this._http.get(url);
  }

  getAprobadores(IdCliente:any){
    const url = environment.URL_BASE+ "cliente/GetAprobador?IdCliente="+IdCliente;
    return this._http.get(url);
  }
}
